import React from "react";
import { MdErrorOutline } from "react-icons/md";

export const TH =
  "px-4 py-3 text-left text-[11px] font-bold uppercase tracking-wide text-gray-700 dark:text-gray-300";
export const TD = "px-4 py-3 text-sm text-gray-600 dark:text-gray-300";
export const ROW =
  "border-b border-gray-100 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-navy-700";
export const WRAP_TABELA =
  "overflow-x-auto rounded-2xl border border-gray-100 bg-white shadow-dv-md dark:border-white/10 dark:bg-navy-800 dark:shadow-none";
export const LABEL = "text-sm font-semibold text-gray-700 dark:text-gray-300";
export const INPUT =
  "w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 transition-all focus:border-dv-blue-500 focus:outline-none focus:ring-2 focus:ring-dv-blue-500/20 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-navy-900 dark:text-white";
export const INPUT_CELULA =
  "w-full min-w-[140px] rounded-lg border border-transparent bg-transparent px-2 py-1.5 text-sm text-navy-700 transition-all hover:border-gray-200 focus:border-dv-blue-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-dv-blue-500/20 dark:text-white dark:hover:border-white/10 dark:focus:bg-navy-900";
export const BTN_PRIMARIO =
  "flex items-center justify-center gap-2 rounded-xl bg-ink-900 px-5 py-2.5 text-sm font-bold text-white shadow-dv-md transition-all hover:bg-ink-800 active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50 dark:bg-white dark:text-ink-900 dark:hover:bg-gray-100";
export const BTN_SECUNDARIO =
  "flex items-center justify-center gap-1.5 rounded-xl border border-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 transition-all hover:bg-gray-50 active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50 dark:border-white/15 dark:text-gray-200 dark:hover:bg-white/5";

export const CHIP = "inline-flex rounded-full px-2.5 py-1 text-[11px] font-semibold";
export const CHIP_VERDE = `${CHIP} bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300`;
export const CHIP_ATENCAO = `${CHIP} bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300`;
export const CHIP_PERIGO = `${CHIP} bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300`;
export const CHIP_NEUTRO = `${CHIP} bg-gray-100 text-gray-600 dark:bg-navy-700 dark:text-gray-300`;

/** Mensagem do backend (`{ message }`) ou o texto padrão. */
export const msgErro = (e: any, padrao: string): string => e?.response?.data?.message || padrao;

export const formatarDataHora = (iso: string | null | undefined): string =>
  iso ? new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "-";

export const Carregando: React.FC<{ rotulo: string }> = ({ rotulo }) => (
  <div
    className="space-y-3 rounded-2xl border border-gray-100 bg-white p-6 dark:border-white/10 dark:bg-navy-800"
    aria-busy="true"
    aria-label={rotulo}
  >
    {[0, 1, 2, 3].map((i) => (
      <div key={i} className="h-10 animate-pulse rounded-xl bg-gray-100 dark:bg-white/5" />
    ))}
  </div>
);

export const Vazio: React.FC<{ texto: string; icone?: React.ReactNode }> = ({ texto, icone }) => (
  <div className="rounded-2xl border border-dashed border-gray-200 p-10 text-center dark:border-white/15">
    {icone && <div className="mx-auto mb-2 flex justify-center text-gray-400 dark:text-gray-500">{icone}</div>}
    <p className="text-sm text-gray-600 dark:text-gray-300">{texto}</p>
  </div>
);

export const Erro: React.FC<{ texto: string; onTentar?: () => void }> = ({ texto, onTentar }) => (
  <div
    role="alert"
    className="flex flex-col gap-3 rounded-2xl border border-red-200 bg-red-50 p-4 text-sm text-red-700 dark:border-red-500/30 dark:bg-red-900/20 dark:text-red-300 sm:flex-row sm:items-center sm:justify-between"
  >
    <span className="flex items-center gap-2">
      <MdErrorOutline className="h-5 w-5 shrink-0" aria-hidden="true" />
      {texto}
    </span>
    {onTentar && (
      <button type="button" onClick={onTentar} className={BTN_SECUNDARIO}>
        Tentar de novo
      </button>
    )}
  </div>
);

/** Minúsculas sem acento nem espaços nas pontas: a busca não diferencia "Ação" de "acao". */
export const normalizar = (texto: string): string =>
  texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
